import {
  PARTNERS_LOADER,
  DOWNLOAD_COUNT,
  SET_PARTNERS_DATA,
  SET_PARTNER_DETAIL_DATA,
  SET_CATEGORIES_DATA,
  SET_PARTNERS_PAGE,
  PAGE_DOWNLOAD_COUNT,
} from "../actionTypes";

const initialState = {
  loader: false,
  partnerDetail: {},
  partners: {},
  partnerCategories: [],
  pageData: {},
};

const partnersReducer = (state = initialState, action) => {
  switch (action.type) {
    case PARTNERS_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_PARTNERS_DATA: {
      return {
        ...state,
        partners: action.payload,
      };
    }
    case SET_PARTNERS_PAGE: {
      return {
        ...state,
        pageData: action.payload,
      };
    }
    case SET_PARTNER_DETAIL_DATA: {
      return {
        ...state,
        partnerDetail: action.payload,
      };
    }
    case SET_CATEGORIES_DATA: {
      return {
        ...state,
        partnerCategories: action.payload,
      };
    }
    case DOWNLOAD_COUNT: {
      if (action.payload == "fileview") {
        return {
          ...state,
          partnerDetail: {
            ...state.partnerDetail,
            fileViewCount: (state.partnerDetail?.fileViewCount || 0) + 1,
          },
        };
      } else
        return {
          ...state,
          partnerDetail: {
            ...state.partnerDetail,
            downloadCount: (state.partnerDetail?.downloadCount || 0) + 1,
          },
        };
    }
    case PAGE_DOWNLOAD_COUNT: {
      if (action.payload == "fileview") {
        return {
          ...state,
          pageData: {
            ...state.pageData,
            fileViewCount: (state.pageData?.fileViewCount || 0) + 1,
          },
        };
      } else
        return {
          ...state,
          pageData: {
            ...state.pageData,
            downloadCount: (state.pageData?.downloadCount || 0) + 1,
          },
        };
    }
    default:
      return state;
  }
};

export default partnersReducer;
